import { render, staticRenderFns } from "./centerPanel.vue?vue&type=template&id=6fc04db3&scoped=true"
import script from "./centerPanel.vue?vue&type=script&lang=js"
export * from "./centerPanel.vue?vue&type=script&lang=js"
import style0 from "./centerPanel.vue?vue&type=style&index=0&id=6fc04db3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc04db3",
  null
  
)

export default component.exports